import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component } from '@angular/core';
import { EnumHelper } from '../../../../helpers/enum.helper';
import { MailAuthType } from '../../../../models/enums/mailauthtype.enum';
import { MailProvider } from '../../../../models/enums/mailprovider.enum';
import { MediaSourceTriggerControl } from './base.trigger.control';

@Component({
    selector: 'mailtrigger-control',
    templateUrl: './mail.trigger.control.html',
    styleUrls: ['./mail.trigger.control.css']
})
export class MailTriggerControl extends MediaSourceTriggerControl {

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    AuthTypes = EnumHelper.GetDropdownValues(MailAuthType);
    Providers = EnumHelper.GetDropdownValues(MailProvider);

    addFrom(event: any): void {
        if (this.TriggerValue) {
            if (!this.TriggerValue.FromSearch) {
                this.TriggerValue.FromSearch = [];
            }
            this.add(event, this.TriggerValue.FromSearch);
        }
    }

    addTo(event: any): void {
        if (this.TriggerValue) {
            if (!this.TriggerValue.ToSearch) {
                this.TriggerValue.ToSearch = [];
            }
            this.add(event, this.TriggerValue.ToSearch);
        }
    }

    addSub(event: any): void {
        if (this.TriggerValue) {
            if (!this.TriggerValue.SubjectSearch) {
                this.TriggerValue.SubjectSearch = [];
            }
            this.add(event, this.TriggerValue.SubjectSearch);
        }
    }

    addAtt(event: any): void {
        if (this.TriggerValue) {
            if (!this.TriggerValue.AttachmentSearch) {
                this.TriggerValue.AttachmentSearch = [];
            }
            this.add(event, this.TriggerValue.AttachmentSearch);
        }
    }

    add(event: any, list: any[]) {
        const input = event.input;
        const value = event.value;

        // Add our fruit
        if ((value || '').trim()) {
            list.push({ SearchValue: value.trim() });
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }
}
